import FundAllocation from "../fundAllocation";
import fundInfo from "../funds";
import FundAllocationCalculation from "../secure/fundAllocationCalculation";
import FundAllocationCalculator from "../secure/fundAllocationCalculator";
import { roundToDecimalPlaces } from "../utilities";

export class CurrentAllocations {
    public totalFunds: number = 0;
    public taxFreeCashLumpSum: number = 0;
    public trusteeBankAccount: number = 0;
    public moneyFund: number = 0;
    public incomeFund: number = 0;
    public growthFund: number = 0;
    public totalLowRisk: number = 0;
    public isValid: boolean = true;
    public moneyFundPercentage: number = 0;
    public incomeFundPercentage: number = 0;
    public growthFundPercentage: number = 0;
    public totalLowRiskPercentage: number = 0;

    public initialise(totalFunds: number, taxFreeCashLumpSum: number) {
        this.totalFunds = Math.round(totalFunds);
        this.taxFreeCashLumpSum = Math.round(taxFreeCashLumpSum);

        this.trusteeBankAccount = Math.round(totalFunds * (FundAllocationCalculator.TrusteeAccountPercentage / 100));

        this.moneyFund = 0;
        this.incomeFund = 0;
        this.growthFund = totalFunds - this.trusteeBankAccount;

        this.updateDerivedProps();
    }

    public updateAllocations(moneyFund: number, incomeFund: number) {
        this.moneyFund = Math.round(moneyFund);
        this.incomeFund = Math.round(incomeFund);
        this.growthFund = this.totalFunds - this.trusteeBankAccount - this.moneyFund - this.incomeFund;

        this.updateDerivedProps();
    }

    public getFundAllocationCalculation(): FundAllocationCalculation {
        const fundAllocations = new Array<FundAllocation>();

        fundAllocations.push(new FundAllocation(fundInfo.trusteeBankAccount, FundAllocationCalculator.TrusteeAccountPercentage, this.trusteeBankAccount));
        fundAllocations.push(new FundAllocation(fundInfo.moneyFund, this.moneyFundPercentage, this.moneyFund));
        fundAllocations.push(new FundAllocation(fundInfo.incomeFund, this.incomeFundPercentage, this.incomeFund));
        fundAllocations.push(new FundAllocation(fundInfo.responsibleGrowthFund, this.growthFundPercentage, this.growthFund));

        return new FundAllocationCalculation(fundAllocations);
    }

    private updateDerivedProps() {
        this.isValid = this.growthFund >= 0;

        this.moneyFundPercentage = this.calcPercentage(this.moneyFund);
        this.incomeFundPercentage = this.calcPercentage(this.incomeFund);
        this.growthFundPercentage = this.growthFund == 0
            ? 0
            : 100 - FundAllocationCalculator.TrusteeAccountPercentage - this.moneyFundPercentage - this.incomeFundPercentage;

        this.totalLowRisk = this.trusteeBankAccount + this.moneyFund + this.incomeFund;
        this.totalLowRiskPercentage = this.totalLowRisk / this.totalFunds;
    }

    private calcPercentage(amount: number): number {
        const percentage = (amount / this.totalFunds) * 100;
        return roundToDecimalPlaces(percentage, 3);
    }
};
